import React, { useEffect, useState } from "react";
import {
    TextField,
} from "@mui/material";

export default function PullModificationTimecodeTextField(props) {
    const { disabled, source, framesToTimeCode, setValue, timeCodeToFrames, value, fps } = props
    const [timeCode, setTimeCode] = useState(framesToTimeCode(value, fps));

    useEffect(() => {
        setTimeCode(framesToTimeCode(value, fps))
    }, [value]);

    const validateTimeCode = (tc) => {
        // Regex to match HH:MM:SS:FF format
        const regex = /^(\d{2,}):([0-5]\d):([0-5]\d):(\d{2,})$/;
        return regex.test(tc);
    }

    const framesInRange = (frames) => {
        const [min, max] = source ?? [0, 0]; // Default to full range if source not defined
        return frames >= min && frames <= max;
    }

    const handleTimeCodeInput = (tc) => {
        if (!validateTimeCode(tc)) {
            setTimeCode(framesToTimeCode(value, fps)); // Reset to previous valid value
            return;
        }
        const frames = timeCodeToFrames(tc, fps);
        if (!framesInRange(frames)) {
            setTimeCode(framesToTimeCode(value, fps)); // Reset to previous valid value
            return;
        }
        setTimeCode(tc)
        setValue(frames)
    }

    return (
        <TextField
            variant="standard"
            disabled={disabled}
            value={timeCode}
            onChange={(e) => setTimeCode(e.target.value)}
            onBlur={(e) => handleTimeCodeInput(e.target.value)}
            onKeyDown={(e) => {
                e.stopPropagation()
                if (e.key === 'Escape') {
                    setTimeCode(framesToTimeCode(value))
                    e.target.blur()
                }
                if (e.key === 'Enter') {
                    e.target.blur()
                }
            }}
            fullWidth
            sx={{
                input: {
                    color: 'white',
                    fontSize: '13px',
                    padding: '4px 8px'
                },
                '& .MuiInput-underline:before': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(84, 162, 119, 0.4)'
                },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(76, 146, 107, 0.8)'
                },
                '& .MuiInput-underline:after': {
                    borderBottom: disabled ? 'none' : '1px solid rgba(84, 162, 119, 1)'
                },
            }}
        />
    )
}